<template>
  <div class="aw-about-us aw-news-index">
    <div class="com-sub-top">
      <div class="title container-center">{{myTitle}}</div>
    </div>
    <div class="tab-box com-desc-box">
        <div class="com-tab-box container-center">
            <div class="p-box">
                <p v-for="item in tabList" :class="{ active: key == item.id }" :key="item.id" @click="choose(item)">{{item.name}}</p>
            </div>
        </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {
        key: '1',
        tabList: [
            {id: '1', name: '企业新闻', path: 'enterprise'},
            {id: '2', name: '大赛', path: 'competition'},
        ]
    };
  },
  methods: {
    choose(val) {
        if(this.key == val.id) return false
        this.key = val.id;
        this.$router.push({ name: val.path });
    },
  },
  computed: {
    myTitle() {
       return this.tabList.find(item => item.id == this.key ).name
    }
  },
  mounted() {
    // let map = {enterprise: '1', competition: '2', enterpriseDetail: '1'}
    // this.key = map[this.$route.name]
  },
  watch: {
    '$route.name': {
      handler(newName) {
        let map = {enterprise: '1', competition: '2', enterpriseDetail: '1'}
        this.key = map[newName]
      },
      immediate: true // 组件创建时立即执行一次
    }
  }
};
</script>